export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4059dd229e4c6c1f430b2d7cf9f53e0c98076c1ac8&name=revalidateCommunity!'